import * as React from "react";
import Parser from "html-react-parser";

type P = {
  backgroundImageSrc?: string;
  title: string;
  description: string;
};
const IntroTextBanner = (props: P) => (
  // export default class IntroTextBanner extends React.Component<P, any> {
  // public render() {
  // const styles = this.props.backgroundImageSrc ? { backgroundImage: `url(${this.props.backgroundImageSrc})` } : {};
  // return (
  <div className="introTextBanner" style={props.backgroundImageSrc ? { backgroundImage: `url(${props.backgroundImageSrc})` } : {}} id="searchBox">
    <div className="introTextBanner__inner">
      <h2 className="introTextBanner__title">{props.title}</h2>
      <p className="introTextBanner__desc center">{Parser(props.description)}</p>
    </div>
  </div>
);
// }
// }
export default IntroTextBanner;



// WEBPACK FOOTER //
// ./src/components/IntroTextBanner.tsx